module.exports = __webpack_public_path__ + "static/media/assa-vial.0288fc2e.svg";